import { render } from "./PlanResources.vue?vue&type=template&id=480b00ce&ts=true"
import script from "./PlanResources.vue?vue&type=script&lang=ts"
export * from "./PlanResources.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__